<template>
    <SystemConfigurationOverlay v-if="isOpen" @close="close" />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import { useSystemConfigurationShortcut } from '@/composables/useSystemConfigurationShortcut';

// Only system administrators ever open it, so the overlay and its pages stay out of everyone else's bundle.
const SystemConfigurationOverlay = defineAsyncComponent(() => import('@/components/layouts/dashboardLayout/systemConfiguration/SystemConfigurationOverlay.vue'));
const { isOpen, close } = useSystemConfigurationShortcut();
</script>
